import {
  Drawer,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuList,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { botActions } from "store/bot";
import { useDispatch, useSelector } from "react-redux";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ConversationMenu from "components/chat/ConversationMenu";
import NewConversationButton from "components/chat/NewConversationButton";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import { useTheme } from "@emotion/react";
import FriendsList from "components/talk/FriendsList";
import ManageFriendsButton from "components/talk/ManageFriendsButton";

export default function TalkDrawerMenu() {

  const isMobile = useIsMobile();
  const theme = useTheme();

  const [menuOpen, setMenuOpen] = useState(false);

  if(!isMobile) return null;

  return (
    <>
      <IconButton
        onClick={() => setMenuOpen(true)}
        color="white"
        data-testid="main-menu-button"
      >
        <QuestionAnswerIcon />
      </IconButton>
      <Drawer
        open={menuOpen}
        anchor="right"
        onClose={() => setMenuOpen(false)}
        sx={{
          width: "300px",
          "& .MuiDrawer-paper": {
            width: "300px",
            boxSizing: "border-box",
            p: 2,
          },
          overflowX: "hidden",
        }}
      >
        <Stack alignItems="center" justifyContent="center">
          <ManageFriendsButton />    
        </Stack>
        <MenuList
          sx={{
            overflowY: "auto",
          }}
        >
          <FriendsList 
            onSelect={() => setMenuOpen(false)}
          />
        </MenuList>
      </Drawer>
    </>
  );
}
